<template>
  <v-card class="data-bgDataTable">
    <!-- cabecera del componente campo de búsqueda -->
    <v-card-title class="data-buscadorDataTable px-4 pb-0">
      <v-text-field color="datPrimary" append-icon="search" v-model="dSearch" :label="this.$t('buscar')"></v-text-field>
    </v-card-title>
    <!-- tabla -->
    <v-card-text class="pb-4 px-0">
      <v-data-table v-model="dItemsChequeados" select-all :headers="pData.headers" :items="pData.items" :rows-per-page-items="dRowsPerPageArray" :no-data-text="this.$t('noResultados')" :no-results-text="this.$t('noResultados')" :pagination.sync="dPagination" :loading="pData.loading" :total-items="pData.totalItems" item-key="id" class="elevation-12 tableApplication tableLoading">
        <!-- cabecera tabla -->
        <template slot="headers" slot-scope="props">
          <tr class="data-gbGreyLight">
            <th id="checkAll" v-if="pData.checkboxOn">
              <v-checkbox primary hide-details @change="fChequeaTodo()" :input-value="props.all" :indeterminate="props.indeterminate"></v-checkbox>
            </th>
            <th class="text-xs-left" v-for="header in props.headers" :key="header.text" :id="header.value" :class="['column sortable', dPagination.descending ? 'desc' : 'asc', header.value === dPagination.sortBy ? 'active' : '',  'text-xs-' + header.align ]" @click="fCambiaOrden(header.value)">
              <v-icon>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <!-- detalle tabla -->
        <template slot="items" slot-scope="props">
          <tr @click="fSeleccionaLinea(props)" :active="props.selected" :style="fActiveStyle(props)">
            <td v-if="pData.checkboxOn" v-on:click.stop>
              <v-checkbox primary hide-details v-model="props.selected" :input-value="props.selected" @change="fChequeaItem(props)"></v-checkbox>
            </td>
            <td class="text-xs-left" :class="fAlineaColumnas(index)" v-if="fCompruebaColumnasVisibles(index)" v-for="(item, index) in props.item" :key="index">{{item}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'DataNewTable',
  props: {
    pData: {
      type: Object,
      required: true,
      default: {
        'items': [],
        'totalItems': 0,
        'rowsPerPage': 0,
        'descending': false,
        'sortBy': '1',
        'page': 1,
        'loading': false,
        'headers': [],
        'checkboxOn': true,
        'selectedApi': '',
        'filterApi': '',
        'initSearch': '',
        'isVisible': true
      }
    }
  },
  data () {
    return {
      dSearch: '',
      dTimerSearch: null,
      dPagination: {'sortBy': this.pData.sortBy, 'descending': this.pData.descending, 'rowsPerPage': this.pData.rowsPerPage},
      dItemsChequeados: [],
      dFilters: [],
      dSelectedItem: {},
      dRowsPerPageArray: [this.pData.rowsPerPage],
      dCargaInicialBusqueda: false
    }
  },
  watch: {
    dSearch: {
      handler () {
        if (!this.dCargaInicialBusqueda) {
          clearInterval(this.dTimerSearch)
          this.dTimerSearch = setTimeout(function () {
            this.fCargaDatosConApi('search')
          }.bind(this), 500)
        } else {
          this.dCargaInicialBusqueda = false
        }
      }
    },
    'pData.initSearch': {
      handler () {
        this.dCargaInicialBusqueda = true
        this.dSearch = this.pData.initSearch
      }
    },
    dPagination: {
      handler () {
        if (this.pData.isVisible) {
          this.fCargaDatosConApi('pagination')
        }
      },
      deep: true
    },
    'pData.items' (items) {
      this.dSelectedItem = items[0]
    }
  },
  created () {
    /*
     * evento de filtrado
     */
    this.$bus.$on(this.pData.filterApi, (filters) => {
      this.dFilters = filters
      this.fCargaDatosConApi('search')
    })
  },
  beforeDestroy () {
    /*
     * evento de filtrado
     */
    this.$bus.$off(this.pData.filterApi)
  },
  methods: {
    /*
     * Comprueba si una priopiedad existe en la cabecera para ver si la muestra o no
     */
    fCompruebaColumnasVisibles (index) {
      for (let i = 0; i < this.pData.headers.length; i++) {
        const header = this.pData.headers[i]
        if (header.value === index) {
          return true
        }
      }
      return false
    },
    /*
     * alinea las columnas
     */
    fAlineaColumnas (index) {
      for (let i = 0; i < this.pData.headers.length; i++) {
        const header = this.pData.headers[i]
        if (header.value === index) {
          return 'text-xs-' + header.align
        }
      }
      return 'text-xs-left'
    },
    fResetPage () {
      this.dPagination.page = 1
      this.dCargaInicialBusqueda = true
      this.dSearch = ''
    },
    /*
     * chequea un solo item
     */
    fChequeaItem (props) {
      props.selected = !props.selected
      if (!props.selected) {
        this.dItemsChequeados.push(props.item)
      } else {
        const index = this.dItemsChequeados.indexOf(props.item)
        if (index > -1) {
          this.dItemsChequeados.splice(index, 1)
        }
      }
      this.$emit('selectItem', this.dItemsChequeados)
    },
    /*
     * chequea todos los items
     */
    fChequeaTodo  () {
      this.dItemsChequeados = (this.dItemsChequeados.length) ? [] : this.pData.items.slice()
      this.$emit('selectItem', this.dItemsChequeados)
    },
    /*
     * cambia el orden de an columna
     */
    fCambiaOrden (column) {
      this.dPagination.page = 1
      this.dPagination.rowsPerPage = this.pData.rowsPerPage

      if (this.dPagination.sortBy === column) {
        this.dPagination.descending = !this.dPagination.descending
      } else {
        this.dPagination.sortBy = column
        this.dPagination.descending = false
      }
    },
    /*
     * selecciona una linea
     */
    fSeleccionaLinea (props) {
      this.dSelectedItem = props.item
      this.$emit('selectItem', props.item)
    },
    /*
     * selecciona una linea
     */
    fActiveStyle (props) {
      return (this.dSelectedItem === props.item) ? 'background:#EEE' : ''
    },
    /*
     * carga datos con el api
     */
    fCargaDatosConApi (operacion) {
      // Si es una búsqueda, reinicia la paginación
      if (operacion === 'search') {
        this.dPagination.page = 1
        this.dPagination.rowsPerPage = this.pData.rowsPerPage
      }
      const object = { sortBy: this.dPagination.sortBy, descending: this.dPagination.descending, page: this.dPagination.page, rowsPerPage: this.dPagination.rowsPerPage, search: this.dSearch, filters: this.dFilters }
      // Llama a la carga de datos
      this.$emit('recharge', object)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components_datadec/DataNewTable.vue